const routes = {
  vehicleList: 'vehicle-list',
  selectionList: 'selection-list',
}

const defaultRoute = routes.vehicleList

export { routes, defaultRoute }
